<app-spinner
  *ngIf="loading"
  mensaje="Procesando reposición..."
></app-spinner>

<p-toast></p-toast>

<p-confirmDialog></p-confirmDialog>

<div class="acciones-footer">

  <button
    pButton
    type="button"
    label="← Volver"
    class="p-button-outlined"
    (click)="volverClick()"
  ></button>

  <button
    pButton
    type="button"
    label="Confirmar"
    class="p-button-primary"
    (click)="confirmarClick()"
  ></button>

</div>
